var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-video-call-layout"},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasError),expression:"!hasError"}],attrs:{"name":"content"}}),_vm._v(" "),(_vm.hasError)?_c('vcr-page-error'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }